import React, { useState, useRef, useEffect } from "react";
import logo from "../assets/images/Logo smart farm1.jpg";
import satellite from "../assets/images/satellite img.png";
import recomIcon from "../assets/images/recomIcon.png";
import Swal from "sweetalert2";
import design from "../assets/images/design.png";
import { Button } from "react-bootstrap";
import { Line } from "react-chartjs-2";

import { useReactToPrint } from "react-to-print";
import {
  FaCloud,
  FaSun,
  FaCloudSun,
  FaCloudRain,
  FaWind,
  FaCalendar,
  FaSmog,
  FaBolt,
  FaSnowflake,
} from "react-icons/fa";
import {
  Chart as ChartJS,
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { MapContainer, TileLayer, ImageOverlay, GeoJSON } from "react-leaflet";
import L from "leaflet";
import satelliteone from "../assets/images/satelliteone.png";
import { useNavigate, useParams } from "react-router";
import api from "../api/api";
import { Spinner } from "react-bootstrap";
import EvapoChart from "../components/Simulation/EvapoChart";
import WaterChart from "../components/Simulation/WaterChart";
import SensorHistoryChart from "./SensorHistoryChart";
import axios from "axios";
import { t } from "i18next";
import { getSensorDepths } from "../utils/sensorDepths";
ChartJS.register(
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
  Title,
  Tooltip,
  Legend
);
const contactInfo = [
  { icon: "fas fa-phone", text: "(+216) 20 340 241" },
  {
    icon: "fas fa-map-marker-alt",
    text: "95 Av. Khaled Ibn El Walid, Tunis 2045",
  },
  { icon: "fas fa-envelope", text: "contact@smartfarm.com.tn" },
  { icon: "fas fa-globe", text: "www.smartfarm.com.tn" },
];

export default function RapportHebdomadaire() {
  const { fieldId } = useParams();
  const Uid = fieldId;
  const ref = useRef(null);
  const handlePrint = useReactToPrint({ contentRef: ref });
  const currentUser = JSON.parse(localStorage.getItem("user") || "{}");

  const [fieldData, setFieldData] = useState(null);
  const [fieldCalcul, setFieldCalcul] = useState(null);
  const [chartData, setChartData] = useState([]);
  const [et0, setET0] = useState(2);
  const [codeSensor, setCodeSensor] = useState("");
  const [historyData, setHistoryData] = useState("");
  const [sensorDepths, setSensorDepths] = useState(getSensorDepths());
  const [forecast, setForecast] = useState([]);
  const [allImages, setAllImages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [isPdf, setIsPdf] = useState(false);
  const [pageReady, setPageReady] = useState(false);
  const navigate = useNavigate();
  const reportPack = fieldData?.farm?.user?.pack ?? currentUser?.pack ?? "ultra";
  const canShowSatelliteSection = reportPack === "ultra";
  const canShowWeatherSection = reportPack !== "basic";
const getLastWeekRange = () => {
  const today = new Date();
  
  // Adjust to local time midnight
  const current = new Date(today.getFullYear(), today.getMonth(), today.getDate());

  // getDay(): Sunday = 0 ... Saturday = 6
  const jsDay = current.getDay(); // e.g., 2 for Tuesday
  const mondayBasedIndex = (jsDay + 6) % 7; // Monday = 0

  // This week's Monday
  const thisMonday = new Date(current);
  thisMonday.setDate(current.getDate() - mondayBasedIndex);
  thisMonday.setHours(0, 0, 0, 0);

  // Last week's Monday
  const lastMonday = new Date(thisMonday);
  lastMonday.setDate(thisMonday.getDate() - 7);
  lastMonday.setHours(0, 0, 0, 0);

  // Last week's Sunday
  const lastSunday = new Date(lastMonday);
  lastSunday.setDate(lastMonday.getDate() + 6);
  lastSunday.setHours(23, 59, 59, 999);

  return {
    dateStart: lastMonday,
    dateEnd: lastSunday,
  };
};



  const [dateValue, setDateValue] = useState(getLastWeekRange());

  useEffect(() => {
    if (isPdf) {
      handlePrint();
      setIsPdf(false);
    }
  }, [isPdf]);

  useEffect(() => {
    if (Uid) {
      api
        .get(`/calcul/field-calcul/${Uid}`)
        .then((res) => {
          const { field, calcul } = res.data;
          setFieldData(field);
          setFieldCalcul(calcul);
          setCodeSensor(field?.sensors?.[0]?.code || "");
        })
        .catch(console.error)
        .finally(() => setLoading(false));
    }
  }, [Uid]);

  useEffect(() => {
    if (fieldData && canShowSatelliteSection) {
      fetchSatelliteImages();
    }
  }, [fieldData, canShowSatelliteSection]);

  const fetchSatelliteImages = async () => {
    try {
      const userUid = JSON.parse(localStorage.getItem("user") || "{}").id;
      const coordinates = JSON.parse(fieldData.coordinates).map(
        ({ Lat, Long }) => [Long, Lat]
      );
      const date = new Date().toISOString().split("T")[0];
      const res = await api.post(
        `/add-satellite-images/${userUid}/${fieldData.id}`,
        { date, coordinates }
      );
      setAllImages(res.data.images || []);
    } catch (err) {
      console.error("Error fetching satellite images:", err);
    }
  };

  useEffect(() => {
    if (fieldCalcul) {
      const today = new Date().toISOString().slice(0, 10);
      const data = [];
      let todayEt0 = 0;

      fieldCalcul.forEach((res) => {
        data.push({
          bilan: res.bilan,
          ETC: res.Etc,
          dates: res.date,
          RUmax: res.RUmax,
          RUmin: res.RUMin,
        });
        if (res.date.startsWith(today)) todayEt0 = res.ET0;
      });

      setET0(todayEt0);
      setChartData(data);
    }
  }, [fieldCalcul]);

  useEffect(() => {
    if (codeSensor) fetchSensorHistory();
  }, [codeSensor, dateValue]);

  const fetchSensorHistory = async () => {
    try {
      const start = formatDate(dateValue.dateStart);
      const end = formatDate(dateValue.dateEnd);
      const res = await api.get(
        `/sensor/sensor-history/${codeSensor}/${start}/${end}?pageNum=0&limit=60`
      );
      setHistoryData(res.data.history);
      setSensorDepths(getSensorDepths(res.data.sensorDepths));
    } catch (err) {
      console.error("Sensor history fetch failed:", err);
    }
  };

  useEffect(() => {
    if (canShowWeatherSection && fieldData?.Latitude && fieldData?.Longitude) {
      fetchWeather();
    }
  }, [fieldData, canShowWeatherSection]);

  const fetchWeather = async () => {
    try {
      const { Latitude: lat, Longitude: lon } = fieldData;

      const [dailyRes, hourlyRes] = await Promise.all([
        fetch(
          `https://api.open-meteo.com/v1/forecast?latitude=${lat}&longitude=${lon}&timezone=auto&daily=temperature_2m_max,temperature_2m_min,precipitation_sum,relative_humidity_2m_max,relative_humidity_2m_min,wind_speed_10m_max,weather_code&forecast_days=7`
        ).then((r) => r.json()),
        fetch(
          `https://api.open-meteo.com/v1/forecast?latitude=${lat}&longitude=${lon}&timezone=auto&hourly=pressure_msl&forecast_days=7`
        ).then((r) => r.json()),
      ]);

      const pressureByDate = {};
      hourlyRes.hourly.time.forEach((timestamp, i) => {
        const date = timestamp.split("T")[0];
        pressureByDate[date] = pressureByDate[date] || [];
        pressureByDate[date].push(hourlyRes.hourly.pressure_msl[i]);
      });

      const formatted = dailyRes.daily.time.map((date, i) => ({
        date,
        day: new Date(date).getDate(),
        tempAvg: Math.round(
          (dailyRes.daily.temperature_2m_max[i] +
            dailyRes.daily.temperature_2m_min[i]) /
            2
        ),
        rain: dailyRes.daily.precipitation_sum[i],
        humidityAvg: Math.round(
          (dailyRes.daily.relative_humidity_2m_max[i] +
            dailyRes.daily.relative_humidity_2m_min[i]) /
            2
        ),
        wind: Math.round(dailyRes.daily.wind_speed_10m_max[i]),
        pressure: pressureByDate[date]
          ? Math.round(
              pressureByDate[date].reduce((a, b) => a + b, 0) /
                pressureByDate[date].length
            )
          : null,
        code: dailyRes.daily.weather_code[i],
      }));

      setForecast(formatted);
    } catch (err) {
      console.error("Weather fetch failed:", err);
    }
  };

  const getFieldBounds = (data) => {
    try {
      const coords = JSON.parse(data.coordinates);
      const lats = coords.map(({ Lat }) => Lat);
      const lngs = coords.map(({ Long }) => Long);
      return [
        [Math.min(...lats), Math.min(...lngs)],
        [Math.max(...lats), Math.max(...lngs)],
      ];
    } catch (err) {
      console.error("Failed to parse field coordinates:", err);
      return null;
    }
  };

  const formatDate = (d) => d.toISOString().split("T")[0];

  const getWeatherIcon = (code) => {
    const icons = {
      sun: [0],
      cloudSun: [1, 2],
      cloud: [3],
      smog: [45, 48],
      rain: [51, 53, 55, 61, 63, 65, 80, 81, 82],
      snow: [71, 73, 75, 85, 86],
      storm: [95, 96, 99],
    };
    if (icons.sun.includes(code)) return <FaSun style={{ color: "#54badf" }} />;
    if (icons.cloudSun.includes(code))
      return <FaCloudSun style={{ color: "#54badf" }} />;
    if (icons.cloud.includes(code))
      return <FaCloud style={{ color: "#54badf" }} />;
    if (icons.smog.includes(code))
      return <FaSmog style={{ color: "#54badf" }} />;
    if (icons.rain.includes(code))
      return <FaCloudRain style={{ color: "#54badf" }} />;
    if (icons.snow.includes(code))
      return <FaSnowflake style={{ color: "#54badf" }} />;
    if (icons.storm.includes(code))
      return <FaBolt style={{ color: "#54badf" }} />;
    return <FaCloud style={{ color: "#54badf" }} />;
  };

  const getIrrigationRecommendation = () => {
    if (!Array.isArray(fieldCalcul)) return "";
    const irrigated = fieldCalcul
      .filter((d) => d.irrigationTime > 0)
      .sort((a, b) => new Date(a.date) - new Date(b.date));
    if (!irrigated.length)
      return "Aucune irrigation n’est prévue pour cette semaine.";

    const formatted = irrigated.map(({ date, irrigationTime }) => {
      const d = new Date(date);
      const hrs = Math.floor(irrigationTime / 60);
      const mins = Math.round(irrigationTime % 60);
      return `${d.getDate().toString().padStart(2, "0")}/${(d.getMonth() + 1)
        .toString()
        .padStart(2, "0")}/${d.getFullYear()} pendant ${hrs}h ${mins}min`;
    });

    const joined =
      formatted.length === 1
        ? formatted[0]
        : formatted.length === 2
        ? formatted.join(" et ")
        : formatted.slice(0, -1).join(", ") + " et " + formatted.slice(-1);

    return `Il est recommandé de répartir les besoins en eau de votre parcelle sur ${irrigated.length} fois par semaine. Pour les prochaines irrigations, prévoyez : ${joined}.`;
  };

  const formatCurrentWeekRange = () => {
    const now = new Date();
    const monday = new Date(
      now.setDate(now.getDate() - ((now.getDay() + 6) % 7))
    );
    const sunday = new Date(monday);
    sunday.setDate(monday.getDate() + 6);

    const format = (d) =>
      d.getDate().toString().padStart(2, "0") +
      "/" +
      (d.getMonth() + 1).toString().padStart(2, "0");
    return `Du ${format(monday)} au ${format(sunday)}`;
  };

  const bounds = getFieldBounds(fieldData);
  useEffect(() => {
    if (
      fieldData &&
      fieldCalcul &&
      (!canShowWeatherSection || forecast.length > 0) &&
      chartData.length > 0
    ) {
      setPageReady(true);
    }
  }, [fieldData, fieldCalcul, forecast, allImages, chartData, canShowWeatherSection]);

  if (!pageReady) {
    return (
      <div
        style={{
          height: "100vh",

          background: "#f2fbfd",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          textAlign: "center",
          padding: "2rem",
          fontFamily: "Arial, sans-serif",
        }}
      >
        <div
          style={{
            border: "8px solid #e0f4f7",
            borderTop: "8px solid #00738e",
            borderRadius: "50%",
            width: "70px",
            height: "70px",
            animation: "spin 1s linear infinite",
            marginBottom: "2rem",
          }}
        ></div>

        <h4 style={{ color: "#00738e", marginBottom: "1rem" }}>
          Rapport en préparation...
        </h4>

        <small
          style={{ fontSize: "0.9rem", color: "#555" }}
          className="text-muted"
        >
          Nous collectons toutes les données de votre champ pour générer un
          rapport détaillé. Merci de votre patience 🍃
        </small>

        {/* Spinner Animation Keyframe */}
        <style>
          {`
          @keyframes spin {
            to { transform: rotate(360deg); }
          }
        `}
        </style>
      </div>
    );
  }

  const downloadBulletin = async () => {
    const fieldUid = Uid; // Make sure `Uid` is defined appropriately
    setIsLoading(true);

    try {
      const res = await api.get(`pdf/${fieldUid}`);
      const data = res.data;

      if (data.success) {
        Swal.fire({
          icon: "success",
          title: t("pdf_generated_success"),
          text: t("pdf_ready_text"),
          showConfirmButton: false,
          timer: 2500,
        }).then(() => {
          window.open(`${process.env.REACT_APP_BASE_URL}/${data.file}`, "_blank");
        });
      } else {
        Swal.fire({
          icon: "error",
          title: t("error"),
          text: t("pdf_generation_error"),
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: t("error"),
        text: t( "pdf_generation_failed"),
      });
      console.error("PDF download error:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div>
      <div
        className="container-fluid bg-white px-4 position-relative pb-5"
        ref={ref}
        style={{
          minHeight: "100vh",
          ...(isPdf && {
            width: "210mm",
            minHeight: "297mm",
            margin: "0 auto",
            boxSizing: "border-box",
            overflow: "hidden", // prevent chart overflows
          }),
        }}
      >
        <div
          className="d-flex justify-content-between align-items-center"
          style={{ height: "100px", flexWrap: "nowrap" }}
        >
          <div style={{ height: "100%" }}>
            <img
              src={logo}
              style={{ height: "100%", width: "auto", maxWidth: "100%" }}
              alt="logo smart farm"
            />
          </div>

          <div
            className="text-white text-center p-2"
            style={{
              background: "#00738e",
              lineHeight: "1.2",
              borderLeft: "5px solid #c1e8ed",
              borderRight: "5px solid #c1e8ed",
              borderBottom: "5px solid #c1e8ed",
              width: "50%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            <h1
              className="text-white m-0"
              style={{
                fontSize: "clamp(1rem, 2.5vw, 3rem)", // min: 1.2rem, max: 3rem
              }}
            >
              Rapport hebdomadaire
            </h1>
            <small>{formatCurrentWeekRange()}</small>
          </div>
        </div>

        {/* client info */}
        <div className=" mt-4">
          <div className="position-relative d-inline-block px-2 py-1 mb-4 rounded">
            <h5
              className="text-info m-0 position-relative"
              style={{ zIndex: 1 }}
            >
              CLIENT INFO
            </h5>
            <div
              className="position-absolute"
              style={{
                bottom: 0,
                left: 0,
                height: "50%",
                width: "100%",
                backgroundColor: "#e3f2f7",
                zIndex: 0,
                borderBottomLeftRadius: "4px",
                borderBottomRightRadius: "4px",
              }}
            ></div>
          </div>

          <div
            className="row text-start small"
            style={{
              fontFamily: "'Courier New', monospace",
              lineHeight: "1.2rem",
              flexWrap: isPdf ? "nowrap" : "wrap",
            }}
          >
            {/* Left Column */}
            <div
              className="col-md-4 mb-2"
              style={{
                flex: isPdf ? "0 0 33.3333%" : undefined, // fixed width for 3 columns in PDF
                maxWidth: isPdf ? "33.3333%" : undefined,
              }}
            >
              <p className="mb-1">
                <span className="text-info fw-bold">CLIENT :</span>{" "}
                {fieldData?.farm.user.name}
              </p>
              <p className="mb-1">
                <span className="text-info fw-bold">NUMERO DE TELEPHONE :</span>{" "}
                {fieldData?.farm.user.phone_number}
              </p>
              <p className="mb-1">
                <span className="text-info fw-bold">FERME :</span>{" "}
                {fieldData?.farm.name}
              </p>
              <p className="mb-1">
                <span className="text-info fw-bold">TERRAIN :</span>{" "}
                {fieldData?.name}
              </p>
            </div>

            {/* Center Column */}
            <div
              className="col-md-4 mb-2"
              style={{
                flex: isPdf ? "0 0 33.3333%" : undefined, // fixed width for 3 columns in PDF
                maxWidth: isPdf ? "33.3333%" : undefined,
              }}
            >
              <p className="mb-1">
                <span className="text-info fw-bold">CULTURE :</span>{" "}
                {fieldData?.crops[0].croptypes.crop}
              </p>
              <p className="mb-1">
                <span className="text-info fw-bold">VARIÉTÉ DE CULTURE :</span>{" "}
                {fieldData?.crops[0]?.varieties?.crop_variety}
              </p>
              <p className="mb-1">
                <span className="text-info fw-bold">TYPE DU SOL :</span>
                {fieldData?.zones[0]?.soiltypes?.soil}
              </p>
            </div>

            {/* Right Column */}
            <div
              className="col-md-4 mb-2"
              style={{
                flex: isPdf ? "0 0 33.3333%" : undefined, // fixed width for 3 columns in PDF
                maxWidth: isPdf ? "33.3333%" : undefined,
              }}
            >
              <p className="mb-1">
                <span className="text-info fw-bold">
                  TYPE SYSTÈME D’IRRIGATION :
                </span>{" "}
                {fieldData?.crops[0].irrigations[0].type === "drip"
                  ? "Goutte à goutte (Drip)"
                  : fieldData?.crops[0].irrigations[0].type}
              </p>
              <p className="mb-1">
                <span className="text-info fw-bold">
                  DÉBIT DE LA SOURCE D’EAU (L/S) :
                </span>{" "}
                {fieldData?.crops[0].irrigations[0].pumpFlow} L/s
              </p>
              <p className="mb-1">
                <span className="text-info fw-bold">
                  DÉBIT DES ARROSEURS (L/H) :
                </span>{" "}
                {fieldData?.crops[0].irrigations[0].flowrate} (L/H)
              </p>
            </div>
          </div>
        </div>

        {/* historique des donnée climatique & historique de lumiditee de sol*/}
        <div
          className="d-flex justify-content-between  mt-4  "
          style={{
            flexWrap: "wrap",
            display: "flex",
            maxHeight: isPdf ? "250px" : "",
          }}
        >
          <div
            className={`${
              isPdf ? "py-2" : "py-5"
            } ${canShowWeatherSection ? "col-sm-5" : "col-12"} col-12 position-relative`}
            style={{
              backgroundColor: "#e3f2f7",
              zIndex: 0,
              borderRadius: "30px",
              height: "calc(100% - 4rem)",
            }}
          >
            <div className=" position-absolute" style={{ top: -15 }}>
              <h5 className="text-info m-0">
                HISTORIQUE DES DONNEES CLIMATIQUE
              </h5>
            </div>

            <div className=" d-flex justify-content-center px-2">
              <SensorHistoryChart
                data={historyData}
                sensorDepths={sensorDepths}
                report={true}
                customTitle="HISTORIQUE DES DONNEES CLIMATIQUE"
                visibleLabels={[
                  "Température de l'air (°C)",
                  "Humidité de l'air (%)",
                  "Pression de l'air (KPa)",
                ]}
              />
            </div>
          </div>
          <div
            className={`${
              isPdf ? "py-2" : "py-5"
            } col-sm-5 col-12 position-relative`}
            style={{
              backgroundColor: "#e3f2f7",
              zIndex: 0,
              borderRadius: "30px",
              height: "calc(100% - 4rem)",
            }}
          >
            <div className=" position-absolute" style={{ top: -15 }}>
              <h5 className="text-info m-0">HISTORIQUE DE L'HUMIDITE DE SOL</h5>
            </div>

            <div
              className=" d-flex justify-content-center px-2"
              // style={{ zIndex: 1 }}
            >
              <SensorHistoryChart
                data={historyData}
                sensorDepths={sensorDepths}
                report={true}
                customTitle="HISTORIQUE DE L'HUMIDITE DE SOL"
                visibleLabels={[
                  `Humidité à ${sensorDepths.mv1}cm`,
                  `Humidité à ${sensorDepths.mv2}cm`,
                  `Humidité à ${sensorDepths.mv3}cm`,
                ]}
              />
            </div>
          </div>
        </div>
        {/*   image satellite */}
        {canShowSatelliteSection && (
        <div
          className={`${
            isPdf ? "py-2 mt-2" : "py-5 mt-4"
          }   col-12 position-relative`}
          style={
            isPdf
              ? {
                  pageBreakInside: "avoid",
                  paddingTop: 0,
                  paddingBottom: "2rem",
                }
              : undefined
          }
        >
          {/* Background box */}
          <div
            className="position-absolute"
            style={{
              top: "4em",
              left: 0,
              height: "calc(100% - 4rem)",
              width: "100%",
              backgroundColor: "#e3f2f7",
              zIndex: 0,
              borderRadius: "30px",
            }}
          ></div>

          {/* 🌍 Satellite image in top-left */}

          <img
            src={satellite}
            alt="decorative satellite"
            style={{
              position: "absolute",
              top: "1em",
              right: "-39px",
              height: "200px",
              zIndex: 5,
              pointerEvents: "none",
            }}
          />

          {/* Title */}
          <div
            className="d-inline-block px-2 py-1 mb-4 position-relative"
            style={{ zIndex: 2 }}
          >
            <h5 className="text-info m-0">IMAGES SATELLITES</h5>
          </div>

          {/* Image previews */}
          <div
            className="position-relative d-flex flex-wrap gap-2 justify-content-md-between justify-content-center mx-2"
            style={
              isPdf
                ? {
                    flexWrap: "nowrap",

                    overflow: "hidden",
                  }
                : undefined
            }
          >
            {bounds &&
              allImages.map((image, i) => (
                <MapContainer
                  key={i}
                  bounds={bounds}
                  style={{
                    height: "200px",
                    width: "100%",
                    maxWidth: "200px",
                  }}
                  scrollWheelZoom={true}
                  zoom={15}
                >
                  <ImageOverlay
                    url={`${process.env.REACT_APP_BASE_URL}${image.image_url}`}
                    bounds={bounds}
                  />
                </MapContainer>
              ))}
          </div>
        </div>
        )}

        {/* etc && prevision meteo*/}

        <div
          className="d-flex justify-content-between flex-wrap gap-4 "
          style={{ marginTop: isPdf ? "20px" : "100px" }}
        >
          {/* FIRST CHART: Modified title */}
          <div
            className={`${
              isPdf ? "py-2" : "py-5"
            } col-sm-5 col-12 position-relative`}
            style={{
              backgroundColor: "#e3f2f7",
              zIndex: 0,
              borderRadius: "30px",
              height: "calc(100% - 4rem)",
            }}
          >
            <div className=" position-absolute" style={{ top: -15 }}>
              <h5 className="text-info m-0">L'évapotranspiration (ETC)</h5>
            </div>

            <div className=" d-flex justify-content-center px-2">
              <EvapoChart data={chartData} report={true} />
            </div>
          </div>

          {/* SECOND PANEL: Weather Forecast Table */}
          {canShowWeatherSection && <div className=" col-sm-6 col-12 ">
            {/* Blue rounded background for entire section */}

            {/* Title */}
            <div className="position-relative d-inline-block px-2 py-1  rounded">
              <h5
                className="text-info m-0 position-relative"
                style={{ zIndex: 1 }}
              >
                PREVISION METEO
              </h5>
              <div
                className="position-absolute"
                style={{
                  bottom: 0,
                  left: 0,
                  height: "50%",
                  width: "100%",
                  backgroundColor: "#e3f2f7",
                  zIndex: 0,
                  borderBottomLeftRadius: "4px",
                  borderBottomRightRadius: "4px",
                }}
              ></div>
            </div>

            {/* Forecast block with white background and rounded corners */}
            <div
              className="position-relative mt-3 "
              style={{
                zIndex: 1,
                fontSize: "12px",
              }}
            >
              {/* Header: Date and weather icon */}
              {/* <div className="d-flex gap-2 justify-content-end align-items-center mb-3">
                <div className="px-3 py-1 rounded-pill bg-info text-white">
                  4.TH | 13° | <FaCloud size={20} />
                </div>
                <div
                  className="px-4  rounded-pill light-row text-info"
                  style={{ paddingTop: 6, paddingBottom: 6 }}
                >
                  APRIL 2016
                </div>
              </div> */}

              {/* Weather forecast data rows */}

              <div className="weather-table align-items-center mt-5">
                {[
                  { label: "Jours", key: "day" },
                  { label: "Temp Moy (°C)", key: "tempAvg" },
                  { label: "Pluie (mm)", key: "rain" },
                  { label: "Humidité de l'air (%)", key: "humidityAvg" },
                  { label: "Pression (Pa)", key: "pressure" },
                  { label: "Vitesse de vent km/h", key: "wind" },
                ]?.map((row, i) => (
                  <div
                    className={`weather-row d-flex ${
                      i % 2 === 0 ? "dark-row" : "light-row"
                    }`}
                    key={i}
                  >
                    <div className="weather-label">{row.label}</div>
                    {forecast.length > 0
                      ? forecast?.map((dayData, j) => (
                          <div className="weather-cell" key={j}>
                            {row.key === "day" ? (
                              <>
                                {getWeatherIcon(dayData.code)}
                                <div>{dayData.day}</div>
                              </>
                            ) : (
                              <>{dayData[row.key]}</>
                            )}
                          </div>
                        ))
                      : Array.from({ length: 7 }).map((_, j) => (
                          <div className="weather-cell" key={j}>
                            –
                          </div>
                        ))}
                  </div>
                ))}
              </div>
            </div>
          </div>}
        </div>
        {/* bilan hydrique*/}
        <div className="d-flex justify-content-between flex-wrap gap-4 mt-sm-5 ">
          <div
            className={`${
              isPdf ? "py-2" : "py-5"
            } col-sm-5 col-12 position-relative`}
            style={{
              backgroundColor: "#e3f2f7",
              zIndex: 0,
              borderRadius: "30px",
              height: "calc(100% - 4rem)",
            }}
          >
            <div className=" position-absolute" style={{ top: -15 }}>
              <h5 className="text-info m-0">BILAN HYDRIQUE</h5>
            </div>

            <div
              className="position-relative d-flex justify-content-center px-2"
              style={{ zIndex: 1 }}
            >
              <WaterChart data={chartData} report={true} />
            </div>
          </div>
          {/* RECOMMANDATIONS SECTION */}
          <div className="col-sm-6 col-12 my-5 position-relative d-flex justify-content-center align-items-center my-md-0">
            {/* Circle card */}
            <div
              className="position-relative bg-white shadow d-flex flex-column align-items-center justify-content-center"
              style={{
                width: "350px",
                height: "350px",
                borderRadius: "50%",
                zIndex: 2,
                textAlign: "center",
                padding: "20px",
              }}
            >
              {/* Curved Top Border */}
              <div
                style={{
                  position: "absolute",
                  top: 0,
                  left: "25%",
                  width: "50%",
                  height: "20px",
                  borderTop: "2px solid #00a3c4",
                  borderRadius: "50%",
                }}
              ></div>

              {/* Curved Bottom Border */}
              <div
                style={{
                  position: "absolute",
                  bottom: 0,
                  left: "25%",
                  width: "50%",
                  height: "20px",
                  borderBottom: "2px solid #00a3c4",
                  borderRadius: "50%",
                }}
              ></div>

              {/* Icon */}
              <div className="mb-2">
                <img
                  src={recomIcon}
                  alt="recomIcon"
                  style={{ width: "70px", color: "#00a3c4" }}
                />
              </div>

              {/* Title */}
              <div className="position-relative d-inline-block px-2 py-1 mb-4 rounded">
                <h5
                  className="text-info m-0 position-relative"
                  style={{ zIndex: 1 }}
                >
                  Recommandation
                </h5>
                <div
                  className="position-absolute"
                  style={{
                    bottom: 0,
                    left: 0,
                    height: "50%",
                    width: "100%",
                    backgroundColor: "#e3f2f7",
                    zIndex: 0,
                    borderBottomLeftRadius: "4px",
                    borderBottomRightRadius: "4px",
                  }}
                ></div>
              </div>
              {/* Text */}
              <p
                className="text-muted small mt-2"
                style={{ lineHeight: "1.1" }}
              >
                {getIrrigationRecommendation()}
              </p>
            </div>
          </div>
        </div>
        <div
          className="position-absolute d-md-block d-none "
          style={{
            bottom: 130,
            right: 70,
            zIndex: 0,
          }}
        >
          <img src={design} alt="design" width={500} />
        </div>
        {/* footer  */}
        <div
          className="row justify-content-between"
          style={{ fontSize: "12px", zIndex: 10, marginTop: 50 }}
        >
          {contactInfo.map((item, index) => (
            <div
              key={index}
              className="col-12 col-sm-6 col-md-4 col-lg-2" // Bootstrap grid for responsiveness
              style={{
                zIndex: 999,
                display: "flex", // Use flex here to align icon and text
                alignItems: "center",
                fontSize: "12px",
                padding: "5px 15px", // Space between icon and text
                marginRight: "15px", // Space between items
                marginBottom: "10px", // Spacing between rows in smaller screens
              }}
            >
              <i
                className={item.icon}
                style={{
                  borderRadius: "50%", // Circle shape for the container
                  border: "1px solid black",
                  padding: 7,
                  marginRight: "5px", // Space between icon and text
                  fontSize: "12px", // Icon size increased for better visibility
                  color: "black",
                  zIndex: 999,
                }}
              ></i>
              {item.text}
            </div>
          ))}
        </div>
        <button
          onClick={downloadBulletin}
          disabled={isLoading}
          className="btn  mt-5"
          style={{ background: "#52B0CF", color: "white" }}
        >
          {isLoading ? "Génération en cours..." : "Générer le PDF"}
        </button>
      </div>
    </div>
  );
}
